import { createApi } from "./client";
import type { TimeSlot } from "../types/models";

type AvailabilityResponse = {
    staffId: number;
    serviceId: number;
    date: string;
    freeSlots: TimeSlot[];
};

export async function getAvailability(
    apiBase: string,
    companySlug: string,
    staffId: number,
    serviceId: number,
    date: string
): Promise<TimeSlot[]> {
    const api = createApi(apiBase);

    const res = await api<AvailabilityResponse>(
        `/api/companies/${companySlug}/availability?staffId=${staffId}&serviceId=${serviceId}&date=${date}`
    );

    return res.freeSlots ?? [];
}
